"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepartmentService = exports.DepartmentInviteService = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const sort_1 = require("../sort");
const index_1 = require("./index");
class DepartmentInviteService {
    constructor(log) {
        this.log = log;
    }
    init() {
        this.userInviteFetchable = new core_shared_1.IkeFetchableMany(this.log, core_shared_1.IkeRest.createStore(), () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield index_1.Services.Department.rest.Department.Invite.list(null);
            return result.results;
        }));
        (0, mobx_1.reaction)(() => index_1.Services.Department.current, () => this.userInviteFetchable.reset());
    }
    get list() {
        return this.userInviteFetchable.value;
    }
    request(emails, role) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_invite:request', String(emails.length), 1);
            yield index_1.Services.Department.rest.Department.Invite.do({ emails, role });
            this.userInviteFetchable.refetch();
            index_1.Services.UserProfile.refresh();
        });
    }
    accept(inviteToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_invite:accept', '', 1);
                yield index_1.Services.User.rest.Department.acceptInvite({ inviteToken });
                yield index_1.Services.User.rest.departments.refetch();
                return true;
            }
            catch (_) {
                return false;
            }
        });
    }
    acceptForce(inviteToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_invite:acceptForce', '', 1);
            yield index_1.Services.Rest.rest.Verify.forceAcceptInvite({ inviteToken });
        });
    }
    checkEmail(inviteToken, email) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Auth, 'User_invite:checkEmail', '', 1);
            const response = yield index_1.Services.Rest.rest.Verify.checkEmail({ checkToken: inviteToken, email });
            return response.results;
        });
    }
    revoke(objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_invite:revoke', '', 1);
            yield index_1.Services.Department.rest.Verify.revoke({
                objectId,
                type: 'invite'
            });
            this.userInviteFetchable.refetch();
        });
    }
    verify(inviteToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_invite:verify', '', 1);
            const response = yield index_1.Services.Rest.rest.Verify.check({
                checkToken: inviteToken,
                type: 'invite'
            });
            return response.results;
        });
    }
}
exports.DepartmentInviteService = DepartmentInviteService;
tslib_1.__decorate([
    mobx_1.computed
], DepartmentInviteService.prototype, "list", null);
class DepartmentService {
    constructor(log) {
        this.log = log;
        this.__priority = 50;
        this.Invite = new DepartmentInviteService(this.log);
        this.departments = mobx_1.observable.array([], { deep: false });
        this.writableDepartments = mobx_1.observable.array([], { deep: false });
        this.adminDepartments = mobx_1.observable.array([], { deep: false });
    }
    init() {
        this.Invite.init();
        (0, mobx_1.reaction)(() => index_1.Services.SSO.token, () => this.updateDepartments());
        (0, mobx_1.reaction)(_ => index_1.Services.UserSettings.departmentId, () => this.updateDepartments());
        (0, mobx_1.reaction)(() => this.current, () => this.updateOrg());
        this.updateDepartments();
    }
    setUserRole(userId, role) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = index_1.Services.Department.rest;
            yield rest.Department.User.role({ userId, role });
            index_1.Services.UserProfile.refresh();
        });
    }
    updateDepartments() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const token = index_1.Services.SSO.token;
            if (token == null) {
                this.departments.clear();
                this.adminDepartments.clear();
                this.writableDepartments.clear();
                this.current = null;
                this.rest = null;
                return Promise.resolve();
            }
            const [departments, adminDepartments, writeableDepartments] = yield Promise.all([
                index_1.Services.User.rest.departments.fetch(),
                index_1.Services.User.rest.adminDepartments.fetch(),
                index_1.Services.User.rest.writeableDepartments.fetch()
            ]);
            this.setDepartments(departments);
            this.setAdminDepartments(adminDepartments);
            this.setWriteableDepartments(writeableDepartments);
        });
    }
    updateOrg() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((_a = this.current) === null || _a === void 0 ? void 0 : _a.orgId) {
                this.currentOrg = (yield index_1.Services.User.rest.Org.getById({ orgId: this.current.orgId }));
            }
        });
    }
    setDepartment(departmentId) {
        const match = this.departments.find(x => x.objectId === departmentId);
        if (match) {
            this.rest = index_1.Services.User.rest.bind(match.objectId);
            this.current = match;
            return;
        }
        throw new Error(`Invalid department: ${departmentId}`);
    }
    hasDepartment(departmentId) {
        for (const department of this.departments) {
            if (department.objectId === departmentId) {
                return true;
            }
        }
        return false;
    }
    /** Check if the user is part of other departments of the same organization */
    get otherDepartmentsInOrg() {
        const current = this.current;
        if (current == null) {
            return [];
        }
        // No longer the case as all organizations have been back-filled. But still possible.
        if (current.orgId == null) {
            return [];
        }
        const otherDepartments = [];
        for (const department of this.departments) {
            if (department.objectId !== current.objectId && department.orgId === current.orgId) {
                otherDepartments.push(department);
            }
        }
        return otherDepartments;
    }
    moveableDepartments() {
        var _a;
        let moveableDepartments = [];
        let isLicensedOrg = Boolean((_a = this.currentOrg) === null || _a === void 0 ? void 0 : _a.licenseCheckFrom);
        const isAnalyst = index_1.Services.User.isIkeAnalyst(index_1.Services.User.current);
        // If the user has elevated permissions, they can move to any department that they have write permissions to
        if (isLicensedOrg || isAnalyst) {
            this.writableDepartments.forEach((department) => {
                var _a;
                // Cant move to current department
                if (department.objectId === ((_a = this.current) === null || _a === void 0 ? void 0 : _a.objectId)) {
                    return;
                }
                moveableDepartments.push(department);
            });
        }
        // Then for every department that the user is in
        this.departments.forEach((department) => {
            var _a, _b;
            // Cant move to current department
            if (department.objectId === ((_a = this.current) === null || _a === void 0 ? void 0 : _a.objectId)) {
                return;
            }
            const isDepartmentOutsideOrg = department.orgId !== ((_b = this.current) === null || _b === void 0 ? void 0 : _b.orgId);
            // We don't want outside org departments (they are handled separately above)
            if (isDepartmentOutsideOrg) {
                return;
            }
            // If is already in the list then skip it
            if (moveableDepartments.find((value) => department.objectId === value.objectId)) {
                return;
            }
            moveableDepartments.push(department);
        });
        return moveableDepartments;
    }
    setAdminDepartments(adminDepartments) {
        this.adminDepartments.clear();
        sort_1.IkeSort.byKey(adminDepartments, 'displayName', sort_1.IkeSort.ASC);
        for (const department of adminDepartments) {
            this.adminDepartments.push(department);
        }
    }
    setWriteableDepartments(writeableDepartments) {
        this.writableDepartments.clear();
        sort_1.IkeSort.byKey(writeableDepartments, 'displayName', sort_1.IkeSort.ASC);
        for (const department of writeableDepartments) {
            this.writableDepartments.push(department);
        }
    }
    setDepartments(departments) {
        this.departments.clear();
        sort_1.IkeSort.byKey(departments, 'displayName', sort_1.IkeSort.ASC);
        if (!index_1.Services.User.hasUser) {
            this.current = null;
            this.rest = null;
            return;
        }
        const departmentId = index_1.Services.UserSettings.departmentId;
        for (const department of departments) {
            if (department.objectId === departmentId) {
                this.current = department;
            }
            this.departments.push(department);
        }
        const nextCurrent = this.current || this.pickDefaultDepartment(departments);
        if (nextCurrent) {
            this.rest = index_1.Services.User.rest.bind(nextCurrent.objectId);
        }
        if (this.current !== nextCurrent) {
            this.current = nextCurrent;
        }
    }
    pickDefaultDepartment(departments) {
        return departments[0] == null ? null : departments[0];
    }
}
exports.DepartmentService = DepartmentService;
tslib_1.__decorate([
    mobx_1.observable
], DepartmentService.prototype, "current", void 0);
tslib_1.__decorate([
    mobx_1.observable
], DepartmentService.prototype, "currentOrg", void 0);
tslib_1.__decorate([
    mobx_1.action
], DepartmentService.prototype, "updateDepartments", null);
tslib_1.__decorate([
    mobx_1.action
], DepartmentService.prototype, "updateOrg", null);
tslib_1.__decorate([
    mobx_1.action
], DepartmentService.prototype, "setDepartment", null);
tslib_1.__decorate([
    mobx_1.computed
], DepartmentService.prototype, "otherDepartmentsInOrg", null);
tslib_1.__decorate([
    mobx_1.action
], DepartmentService.prototype, "moveableDepartments", null);
tslib_1.__decorate([
    mobx_1.action
], DepartmentService.prototype, "setAdminDepartments", null);
tslib_1.__decorate([
    mobx_1.action
], DepartmentService.prototype, "setWriteableDepartments", null);
tslib_1.__decorate([
    mobx_1.action
], DepartmentService.prototype, "setDepartments", null);
//# sourceMappingURL=department.service.js.map